export default __webpack_public_path__ + "static/media/Final2.d5ba157a.ogg";